<template>
    <div>
        <StatusMessage
            v-if="message"
            class="w-full mt-4"
            :initialMessage="message"
            type="success"
        />

        <fieldset class="space-y-6">
            <legend class="sr-only">Email Lists</legend>
            <div
                v-for="campaign in campaigns"
                :key="campaign.id"
                class="relative flex items-start"
            >
                <div class="shrink-0 flex items-center h-5">
                    <input
                        @click="toggleSubscription(campaign.id)"
                        :checked="isSubscribedTo(campaign.id)"
                        :name="campaign.id"
                        type="checkbox"
                        class="h-4 w-4 text-nutreance-green border-gray-300 rounded focus:ring-transparent"
                    />
                </div>
                <div class="ml-3 text-sm">
                    <label
                        :for="campaign.id"
                        class="font-semibold text-gray-700"
                        >{{ campaign.display_name }}</label
                    >
                    <p class="text-gray-500">{{ campaign.description }}</p>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import StatusMessage from "../StatusMessage.vue";
import {
    subscribeToCampaign,
    unsubscribeFromCampaign,
} from "../../api/mailCampaigns";

const props = defineProps<{
    campaigns?: any;
    subscriberId: number;
    initialMessage?: string;
    initialSubscribedCampaignIds?: any;
}>();

const subscribedCampaignIds = ref(props.initialSubscribedCampaignIds);
const message = ref(props.initialMessage);

function isSubscribedTo(campaignId: number) {
    return subscribedCampaignIds.value.includes(campaignId);
}

function toggleSubscription(campaignId: number) {
    return isSubscribedTo(campaignId)
        ? unsubscribeFrom(campaignId)
        : subscribeTo(campaignId);
}

function unsubscribeFrom(campaignId: number) {
    unsubscribeFromCampaign(props.subscriberId, campaignId).then(
        (data: any) => {
            subscribedCampaignIds.value = data.subscribedCampaignIds;
            message.value = data.message;
        },
    );
}

function subscribeTo(campaignId: number) {
    subscribeToCampaign(props.subscriberId, campaignId).then((data: any) => {
        subscribedCampaignIds.value = data.subscribedCampaignIds;
        message.value = data.message;
    });
}
</script>
